import {Component, computed, inject} from '@angular/core';
import {NavigationEnd, Router, RouterModule} from '@angular/router';
import {SessionService} from '../../core/session.service';
import {NgOptimizedImage} from '@angular/common';
import {NzLayoutModule} from 'ng-zorro-antd/layout';
import {NzMenuModule} from 'ng-zorro-antd/menu';
import {NzAvatarModule} from 'ng-zorro-antd/avatar';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzDrawerModule} from 'ng-zorro-antd/drawer';
import {NzDescriptionsModule} from 'ng-zorro-antd/descriptions';
import {activeUrl$, breakpoint$, title$} from '../../core/ui-state';
import {user$} from '../../core/session';
import {UserPanelComponent} from './user-panel.component';
import {filter, map} from 'rxjs';
import {NzBreakpointService, siderResponsiveMap} from 'ng-zorro-antd/core/services';
import {NzIconModule} from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-layout',
  imports: [
    RouterModule,
    NzLayoutModule,
    NzMenuModule,
    NzAvatarModule,
    NzButtonModule,
    NzDrawerModule,
    NzDescriptionsModule,
    NgOptimizedImage,
    NzIconModule,
    UserPanelComponent
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.less'
})
export class LayoutComponent {

  session = inject(SessionService)
  user$ = user$;
  title$ = title$;
  xs$ = computed(() => {
    return breakpoint$() === 'xs';
  });

  router = inject(Router);
  breakpoint = inject(NzBreakpointService);
  showUserPanel = false;
  titles: any[] = user$()?.menus.reduce((a, m) => {
    m.menu_items.forEach(s => {
      a.push({
        pattern: `/${m.link}/${s.link}`,
        parent: m.id,
        text: s.text
      });
    });
    return a;
  }, []);

  openMap: { [name: string]: boolean } = user$()?.menus.reduce((a: any, m) => {
    a[m.id] = true;
    return a;
  }, {});


  constructor() {
    this.breakpoint.subscribe(siderResponsiveMap).subscribe((c: any) => {
      breakpoint$.set(c);
    });

    this.router.events.pipe(
      filter(v => v instanceof NavigationEnd),
      map((v: any) => v.url)
    ).subscribe((url) => {
      activeUrl$.set(url);
      const title = this.titles.find(t => t.pattern.startsWith(url));
      title$.set(title?.text || 'Welcome');
      this.openHandler(title?.parent);
    });

  }

  async logout() {
    await this.session.signOut();
  }

  openHandler(value: any): void {
    const valueStr = `${value}`;
    for (const key in this.openMap) {
      if (key !== valueStr) {
        this.openMap[key] = false;
      }
    }
  }

}
